define([
	"dojo/_base/declare",
	"csi/table/matrix/Path",
	"csi/xml"
], function(declare,PathMatrix,xml) {

	return declare(PathMatrix, {
		sortAttr: "Color", //TA31405

        addDependencyPaths: function(/*Heading*/h, /*String[]*/paths) {
            // summary: add any dependency paths necessary to process matrix
            paths.push(xml.path(h.m_id, this.sortAttr));
            this.inherited(arguments);
        }
	});
});